export const contactsData = {
    email: 'shubhamdubey.dubey4@gmail.com',
    phone: '+91-9839839111',
    address: 'Varanasi,Uttar Pradesh,India, 221005',

    sheetAPI: 'https://sheetdb.io/api/v1/yr50xb3090whl'
}